module.exports = __webpack_public_path__ + "static/media/ncc.501f0ea9.jpeg";